import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').ContactDetails}
 */
const ContactDetails = ({
    title,
    standfirst,
    items
}) => {

    // render
    return (
        <div className='col-12 flex flex-wrap justify-between'>
            <div className='col-12 sm-col-6 md-col-5 mb5 sm-mb0'>
                <h2 className='type-style-1'>{title}</h2>
            </div>
            <div className='col-12 sm-col-6 flex-col'>
                <div className='col-10 mb6 md-mb7'>
                    <div
                        className='rich-text type-style-3'
                        dangerouslySetInnerHTML={{__html: standfirst}} />
                </div>
                <div className='flex flex-wrap'>
                    {items.map((item, idx) => {
                        if (!item) { return null; }

                        const { title, emailAddress } = item;

                        return (
                            <div
                                className={`col-12 md-col-6 sm-mb5 md-mb0${idx ? ' mt5 sm-mt0' : ''}`}
                                key={`contact-details-${idx}`}>
                                <h3 className='col-10 type-style-3 mb5'>{title}</h3>
                                <a
                                    className='link-reset type-style-6'
                                    href={`mailto:${emailAddress}`}>{emailAddress}</a>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ContactDetails;
